<template>
  <Teleport :to="teleportTo">
    <Transition name="panel">
      <div
        v-if="isOpen"
        class="bottom-panel"
        :class="{ 'is-collapsed': isCollapsed }"
        :style="{ width: `${width}px` }"
      >
        <div class="bottom-panel-header">
          <slot name="header" />
          <NewTooltip v-if="hasClose" placement="top" :arrow="true" :content="$t('bottom-panel-close-panel')">
            <WithIconButton
              :icon-name="'closeIconGray'"
              :variant="ButtonVariant.TERTIARY_GRAY"
              :size="ButtonSize.SMALL"
              :text="''"
              :disable-hover="true"
              aria-label="Close panel"
              @click="$emit('close')"
            />
          </NewTooltip>
        </div>

        <div class="bottom-panel-body-wrapper">
          <div class="bottom-panel-body">
            <slot />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ButtonVariant, ButtonSize } from '@/styles/types'
import WithIconButton from '@/components/common/buttons/WithIconButton.vue'
import { NewTooltip } from '@/components/common'

withDefaults(
  defineProps<{
    isOpen: boolean
    isCollapsed?: boolean
    width?: number
    hasClose?: boolean
    teleportTo?: string
  }>(),
  {
    isCollapsed: false,
    width: 316,
    hasClose: true,
    teleportTo: 'body'
  }
)

defineEmits<{
  (e: 'close'): void
}>()
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';

.bottom-panel {
  position: fixed;
  bottom: 0;
  right: 32px;
  background: $white;
  border-radius: 8px 8px 0 0;
  box-shadow: 2px 2px 10px 0 hsla(243, 15%, 30%, 0.1);
  z-index: $zIndex2;
  overflow: hidden;
  border: 1px solid $display-neutrals-300;
}

.bottom-panel-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 12px 12px 16px;
}

.bottom-panel-body-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease-out, opacity 0.2s ease;
  opacity: 0;
}

.bottom-panel:not(.is-collapsed) .bottom-panel-body-wrapper {
  grid-template-rows: 1fr;
  opacity: 1;
}

.bottom-panel-body {
  overflow: hidden;
  min-height: 0;
}

.panel-enter-active,
.panel-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.panel-enter-from,
.panel-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

</style>


